/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_DescriptionInputs */

const en_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding anime guide: where to watch on Crunchyroll and Noitamina, the 2026 episode schedule, a spoiler-light story, characters and news.`)
};

const zh_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画一站式指南：Crunchyroll 与ノイタミナ观看渠道、2026 年播出时间表、轻剧透剧情介绍、角色与声优、最新消息。`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding anime guide: where to watch on Crunchyroll and Noitamina, the 2026 episode schedule, a spoiler-light story, characters and news." |
*
* @param {Common_Metadata_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_metadata_description = /** @type {((inputs?: Common_Metadata_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_metadata_description(inputs)
	return zh_common_metadata_description(inputs)
});
export { common_metadata_description as "common.metadata.description" }